/* eslint-disable */
import axios from "axios";

export default {
    data() {
        return {
            videos: [],
            currentVideo: null,
            playerVars: {
                autoplay: 1
            }
        };
    },
    created() {
        window.scrollTo(0, 0);
        this.getVideos();
    },
    methods: {
        getVideos() {
            axios
                .get(
                    "https://www.googleapis.com/youtube/v3/search?key=AIzaSyBnsVnqQ2qHRyXSu8ZJRXM4Tbxn2lQatQI&channelId=UC4tUadsFU_-rLzYD7UxHFEg&part=snippet,id&order=date&maxResults=24"
                )
                .then(response => {
                    // JSON responses are automatically parsed.
                    this.videos = response.data.items;
                })
                .catch(e => {
                    this.errors.push(e);
                });
        },
        truncate(string) {
            if (string.length > 40) {
                return string.substring(0, 40) + "...";
            } else {
                return string;
            }
        },
        playing() { }
    }
};


// WEBPACK FOOTER //
// ./src/components/videos/video.page.js